export default {
  login: {
    title: '大连豪森智源官网管理平台',
    logIn: '登录',
    username: '账号',
    password: '密码',
    useridplaceholder: '请输入用户名',
    passwordplaceholder: '请输入密码',
    lineidplaceholder: '请选择线体编号',
    useridlength: '用户名的长度大于5位小于20位',
    passwordlength: '密码的长度大于5位小于10位',
    factoryIdAndLineidVerify: '线体编号必须选择',
    copyright: 'copyright@大连豪森智源数据有限公司'
  },
  request: {
    title: '确定登出',
    confirmtext: '重新登录',
    canceltext: '取消',
    interface404: '数据服务器接口{0}不存在请联系管理员',
    interface504: '数据服务器崩溃请联系管理员',
    sessionExpired: '由于长时间未操作，请登出重新登录'
  },
  general: {
    postion: '输入长度在2-10个字符之间',
    crafname: '请输入工艺名称',
    crafnameNotNull: '工艺名称不能为空',
    PositiontitleNotNull: '职位不能为空',
    title: '工艺名称',
    titleNotNull: '工艺名称不能为空',
    isDisable: '是否禁用',
    opId: '工位编号',
    cancelReceive: '已取消接收任务',
    downtime: '停机时间报表',
    ProductionStatistics: '生产量统计',
    AnalysisofCp: '工序能力分析图表',
    tountil: '至',
    // taskstatusquery: '任务状态查询',
    taskstatusquery: '生产计划统计',
    taskclosedstatusquery: '关闭任务状态查询',
    produceNum: '序列号',
    close: '任务关闭',
    deselect: '取消选择',
    rise: '排序上升',
    decline: '排序下降',
    issued: '任务下达',
    freeze: '任务冻结',
    receive: '接收',
    prompt: '提示',
    search: '查询',
    create: '新建',
    delete: '删除',
    refresh: '刷新',
    modify: '编辑',
    xiazai: '下载',
    particular: '详细',
    actionButton: '操作按钮',
    config: '配置',
    sure: '确定',
    cancel: '取消',
    operation: '操作',
    submit: '提交',
    goBack: '返回',
    isdisabled: '是否禁用',
    grid: '数据表格',
    password: '密码',
    factoryId: '工厂编号',
    factoryName: '工厂名称',
    lineId: '线体编号',
    lineName: '线体名称',
    assemblyLineId: '装配线编号',
    assemblyLineName: '装配线名称',
    postionConfig: '职位配置',
    postionName: '职位名称',
    factoryassemblyholder: '请选择工厂及装配线信息',
    subassemblylineid: '分装线编号',
    subassemblylinename: '分装线名称',
    subassemblylinenameplaceholder: '请选择分装线',
    opid: '工位编号',
    opname: '工位名称',
    positionselect: '请选择工位',
    programid: '程序号',
    programname: '程序号名称',
    productmodel: '机型号',
    producttypeid: '机种号',
    productmodelname: '产品名称',
    actionid: '动作编号',
    actionname: '动作名称',
    stepid: '工步编号',
    stepname: '工步名称',
    ordernumber: '订单号',
    serialNumber: '流水号',
    configured: '已配置',
    notconfigured: '未配置',
    forbidden: '禁用',
    notforbidden: '启用',
    alldata: '全部数据',
    attention: '注意',
    deleteattention: '删除本条数据将会同时删除所有与本条数据有关的关联关系',
    deleteConfirm: '此操作将永久删除该数据, 是否继续?',
    receiveConfirm: '此操作将接受ERP订单, 是否继续?',
    lengthplaceholder: '输入内容过长',
    numberholder: '请输入数字',
    productmixplaceholder: '请输入长度20以内的字母或数字',
    numberorword: '请输入字母或数字',
    serialNumberplaceholder: '请输入流水号',
    keyword: '请输入工位关键字',
    selectproduct: '选择产品',
    mainline: '主线',
    updateUserId: '更新者ID',
    updateUserName: '更新者姓名',
    updateDate: '更新时间',
    operationDate: '操作时间',
    insertUserId: '插入者ID',
    insertUserName: '插入者姓名',
    insertDate: '插入时间',
    productIdAreaMin: '序列号开始值',
    productIdAreaMax: '序列号结束值',
    productIdAreaPlaceholder: '请输入序列号',
    factoryIdPlaceholder: '请输入工厂编号',
    factoryNamePlaceholder: '请输入工厂名称',
    selectFactoryId: '请选择工厂名称',
    lineIdPlaceholder: '请输入线体编号',
    lineNamePlaceholder: '请输入线体名称',
    opCodePlaceholder: '请输入工位编号',
    opCodeenter: '请选择工位名称',
    errString: '不支持特殊字符',
    rangLength0_20: '长度为0到20 个字符',
    maxLength1: '请输入数字0~9',
    maxLength5: '请输入长度在5个字符以内',
    maxLength10: '请输入长度在10个字符以内',
    maxLength20: '请输入长度在20个字符以内',
    maxLength30: '请输入长度在30个字符以内',
    maxLength50: '请输入长度在50个字符以内',
    maintainIdPlaceholder: '请输入维护计划编号',
    factoryIdNotNull: '工厂编号不能为空',
    lineIdNotNull: '线体编号不能为空',
    factoryNameNotNull: '工厂名称不能为空',
    lineNameNotNull: '线体名称不能为空',
    orderNumberNotNull: 'ERP任务号不能为空',
    serialNumberNotNull: '流水号不能为空',
    planformNotNull: '平台号不能为空',
    enginetypelittlenotNull: '机种号不能为空',
    programNumNotNull: '程序号不能为空',
    enginetypenotNull: '机型号不能为空',
    ordercountnotNull: '订单数量不能为空',
    opNumNotNull: '工位号不能为空',
    opNameNotNull: '工位名称不能为空',
    andonCodeNotNull: '安东类型不能为空',
    andonLevelNotNull: '安东等级不能为空',
    andonContentNotNull: '安东类型描述不能为空',
    produceNumNotNull: '程序号不能为空',
    remarkNotNull: '备注信息不能为空',
    remarkPlaceholder: '请输入备注信息',
    engineTypePlaceholder: '请输入机型号',
    engineTypeLittlePlaceholder: '请输入机种号',
    platformIdPlaceholder: '请输入平台号',
    maintainIdNotNull: '维护计划不能为空',
    maintainIdExisted: '维护计划已存在',
    version: '版本号',
    newSuccess: '新建成功',
    updateSuccess: '修改成功',
    updateFailure: '修改失败',
    deleteSuccess: '删除成功',
    reseiveSuccess: '接收成功',
    deleteFailed: '删除失败',
    cancelDelete: '已取消删除',
    chooseData: '请选中一条数据',
    disableorenable: '是否禁用',
    ERPordernum: '订单号',
    producedate: '生产日期',
    shift: '班次',
    offline: '下线数量',
    online: '上线数量',
    okcount: '合格数量',
    ngcount: '不合格数量',
    platform: '平台号',
    datetime: '请选择日期',
    datestart: '开始时间',
    dateend: '结束时间',
    timeFormatterWraning: '时间格式错误',
    timeFormatterWraning1: '休息时间大于班次结束与开始时间差,请重新选择时间',
    yes: '是',
    no: '否',
    all: '全部',
    noResponseWarningMessage: '无符合查询条件数据',
    downloading: '下载中',
    downloadingWarning: '导出失败',
    line: '折线图',
    bar: '柱状图',
    pie: '饼图',
    maxValue: '最大值',
    minValue: '最小值',
    avgValue: '平均值',
    maxPoint: '最高点',
    minPoint: '最低点',
    timeValueWarningMessage: '请输入时间查询条件',
    placeholderStart: '开始时间',
    rangeSeparatoe: '至',
    placeholderEnd: '结束时间',
    timeValueOnLine: '上线时间范围',
    timeValueOffLine: '下线时间范围',
    pickerOptionsShortcutsText1: '最近一周',
    pickerOptionsShortcutsText2: '最近一个月',
    pickerOptionsShortcutsText3: '最近三个月',
    groups: '样本组数',
    extract: '样本间隔',
    count: '每组样本数',
    groupsPlaceholder: '请输入样本组数',
    extractPlaceholder: '请输入样本抽取间隔',
    countPlaceholder: '请输入每组样本数',
    groupsNotNull: '组数不能为空',
    extractNotNull: '间隔不能为空',
    countNotNull: '每组样本数不能为空',
    on: '启用',
    off: '禁用',
    viewImage: '浏览',
    deleteImage: '删除图片',
    uploadPhoto: '上传图片',
    reUpdate: '重新上传',
    showMore: '更多',
    confirmUpdate: '确认保存',
    updateattention: '确认保存修改该权限？',
    cancelUpdate: '成功取消保存',
    station: '台',
    xiugairen: '修改人姓名',
    delaytime: '定时任务',
    maintenancecontentsNotNill: '定时内容不能为空',
    view: '预览',
    orderState: '订单状态',
    pleasSeselectTime: '请选择时间段格式'
  },
  AlarmHistory: {
    // title: '设备报警查询',
    title: '报警信息查询',
    alarmTypeCode: '报警类别代码',
    alarmTypeName: '报警文本',
    alarmLevel: '报警级别',
    callTime: '呼叫时间',
    resetTime: '呼叫解除时间',
    lastTime: '持续时间(秒)',
    productIdPlaceholder: '请输入产品编号',
    productId: '流水号'
  },
  MacFactoryLine: {
    title: '线体字典',
    title2: '工厂字典',
    title3: '工位管理',
    listTitle: '工厂信息列表',
    factoryNamePlaceholder: '请输入工厂名称',
    lineNamePlaceholder: '请输入线体名称',
    role: '角色',
    assignedstatus: '角色分配',
    checkuserid: '检查用户ID',
    resetpassword: '重置密码',
    checksuccess: '工厂线体ID可用',
    checkfail: '工厂或线体ID重复',
    checkFactoryLine: '检查工厂线体ID',
    useridlengthplaceholder: '长度在 5 到 10 个字符之间',
    usernamelengthplaceholder: '长度在 20 个字符以内',
    assignlistselectplaceholder: '请为当前用户选择至少一个角色'
  },
  CraDisposalType: {
    title: '处置类别字典',
    type: '类别',
    judgeType: '判定类别',
    disposalMethod: '处置方法',
    validateType: '类型不能为空',
    validateJudgeType: '判定类别不能为空',
    validateMethod: '处置方法不能为空'
  },
  MachiningStatistics: {
    title1: '不合格件录入',
    title2: '不合格件查询',
    title3: '试漏件录入',
    title4: '试漏件查询',
    title5: '合格率查询',
    title6: '合格件录入',
    title7: '合格件查询',
    frameNumber: '框号',
    save: '保存',
    partNumber: '零件号',
    manufacturer: '毛坯厂家',
    mouldNumber: '模具号',
    batchNumber: '批次号',
    judgeType: '判定类别',
    disposalMethod: '处置方法',
    number: '序号',
    frameNumberValidate: '框号不能为空',
    partNumberValidate: '零件号不能为空',
    manufacturerValidate: '毛坯厂家不能为空',
    mouldNumberValidate: '模具号不能为空',
    batchNumberValidate: '批次号不能为空',
    judgeTypeValidate: '判定类别不能为空',
    disposalMethodValidate: '处置方法不能为空',
    isEmpty: '有未填行',
    updateDate: '操作时间',
    type: '类型',
    leaveTime: '出厂时间',
    backTime: '入场时间',
    testNumber: '已试漏次数',
    timeEmpty: '时间不能为空',
    timeTypeEmpty: '类型或时间为空',
    timeIsEmpty: '时间为空',
    parts: '行零件在合格或不合格表中已存在'
  },
  BaTechStepDescription: {
    stepDescription: '工步描述',
    descriptionnotNull: '工步描述不能为空',
    deleteData: '请确认是否删除整条数据？',
    title: '工步描述配置'
  },
  BaTechTightenPosition: {
    title: '工艺工步配置',
    upload: '图片是否上传',
    stepStyle: '工步类型',
    stepStyleNotNull: '工步类型不能为空',
    deleteData: '删除整条数据',
    deleteData1: '确认删除整条数据?',
    selectStepStyle: '请选择工步类型',
    screwDown: '拧紧',
    pressFitting: '压装',
    failSafe: '防错',
    scan: '扫码',
    text: '文本',
    other: '其他',
    extend: '是否扩展',
    no: '否',
    yes: '是',
    extendId: '扩展编号',
    enterExtendId: '请输入扩展编号',
    hideNumber: '隐藏数字',
    showNumber: '显示数字',
    addPhotograph: '该机型未添加图片请先添加图片',
    pictureUploaded: '图片上传成功',
    deletePicture: '确认删除该机型图片?',
    noPicture: '该机型无图片',
    noPut: '未上传',
    yesPut: '已上传',
    insterStep: '工步保存成功',
    updateExtend: '扩展操作',
    noExtend: '该机型无扩展',
    isStep: '一张图片最多存放50个工步',
    fileTypeError: '只能上传图片类型文件',
    craftName: '工艺名称',
    craftNameNotNull: '工艺名称不能为空'
  },
  CraTechBom: {
    // title: '本地BOM配置',
    title: '物料管理',
    copy: '复制',
    delBoms: '批量删除',
    bomList: '物料列表',
    id: 'ID',
    factoryId: '工厂编号',
    lineId: '线体编号',
    opId: '工位号',
    platformId: '平台号',
    engineTypeLittle: '机种号',
    engineType: '机型号',
    assemblyCode: '组件编码',
    assemblyName: '组件描述',
    supplier: '供应商',
    consumeQuantity: '消耗数量',
    isScanning: '是否扫描',
    isMainMaterial: '是否主物料',
    operateTime: '操作时间',
    export: '导出',
    import: '导入',
    importTips: '只能上传xlsx文件',
    scanning0: '不需要扫描',
    scanning1: '需要扫描',
    mainMaterial0: '非主物料',
    mainMaterial1: '主物料',
    toolbar: '工具栏',
    temType: '模板机型',
    newType: '新增机型',
    delType: '请选择删除机型',
    assemblyCodeValidate: '组件编码不能为空',
    assemblyNameValidate: '组件描述不能为空',
    consumeQuantityValidate: '消耗数量不能为空',
    chooseFactoryLine: '请选择工厂线体',
    copySuccess: '复制成功',
    importSucces: '导入成功',
    importFailed: '导入失败',
    importTypeError: '导入文件格式有误',
    tableEmpty: '表格为空，不能导出',
    taskIdValidate: '任务Id不能为空',
    taskNameValidate: '任务名称不能为空',
    taskQuantity: '任务数量不能为空',
    chooseFile: '选择文件',
    downtemp: '下载模板',
    no: '序号',
    importtitle: '本地Bom配置导入',
    importFactoryTitle: '工厂Bom配置导入',
    save: '确认保存',
    clear: '清除',
    savesuccess: '保存成功',
    importerr: '导入数据有误',
    clearSuccess: '清除成功',
    clearfailed: '清除失败',
    checkproblem: '校验问题描述',
    pleaceChooseFile: '请先选择文件'
  },
  PerShift: {
    title: '班次管理',
    factoryId: '工厂名称',
    lineId: '线体名称',
    workShiftId: '班次编号',
    workShiftName: '班次名称',
    workShiftStartTime: '班次开始时间',
    workShiftEndTime: '班次结束时间',
    workShiftWorkTime: '班次工作时间',
    pworkShiftStartTime: '请选择班次开始时间',
    pworkShiftEndTime: '请选择班次结束时间',
    nworkShiftId: '班次编号不能为空',
    nworkShiftName: '班次名称不能为空',
    nworkShiftStartTime: '班次开始时间不能为空',
    nworkShiftEndTime: '班次结束时间不能为空',
    pfactoryId: '请输入工厂名称',
    plineId: '请输入线体名称',
    pworkShiftId: '请输入班次编号',
    pworkShiftName: '请输入班次名称',
    ptimeOutStart: '请输入休息开始时间',
    ptimeOutEnd: '请输入休息结束时间',
    ptimeOut: '请输入休息时间信息',
    timeOut: '休息时间',
    workShiftOrder: '班次序号',
    showBreakTimeList: '查看休息时间',
    timeOutNumber: '休息次数',
    timeOutStartTime: '休息开始时间',
    timeOutEndTime: '休息结束时间',
    addTimeOut: '添加休息时间',
    breakTime: '休息时间段',
    pworkShiftOrder: '请输入班次序号',
    updateUserName: '编辑者',
    No: '第',
    shift: '班次',
    workShiftTimeOver24Hours: '工作时间总长度大于24小时，请重新输入',
    setBreakTimeDuringWorkShiftTime: '请在该班次的工作时间段内设置休息时间',
    enterLastShiftOfBreakEndTIme: '请输入该班次的上一次休息结束时间',
    enterBreakTimeOutsideLastShiftOfBreakEndTIme: '请在该班次的上一次休息结束时间段外设置休息时间',
    breakStartTimeIsWrongBeyondWorkShiftTime: '的休息开始时间输入有误，超出了工作时间范围。请重新输入',
    breakEndTimeIsWrongBeyondWorkShiftTime: '的休息结束时间输入有误，超出了工作时间范围。请重新输入',
    breakStartTimeIsWrong: '的休息开始时间输入有误。请重新输入',
    breakTimeGreaterThanWorkShiftTime: '休息时间大于等于工作时间，请检查后重新输入',
    lastShiftEndTime: '上一班次结束时间为：',
    nextShiftStartTime: '下一班次开始时间为：',
    workShiftStartTimeIllegal: ' ，工作开始时间不合法，请重新输入',
    workShiftEndTimeIllegal: ' ，工作结束时间不合法，请重新输入',
    wrongDate: '数据输入有误，请检查',
    workShiftTimeIllegal: '工作时长无效（工作时长不能小于0），请重新输入结束工作时间'
  },
  MacMachAlarm: {
    title: '设备报警',
    listTitle: '报警基础配置列表',
    factoryId: '工位编号',
    factoryName: '工位名称',
    lineId: '线体编号',
    lineName: '线体名称',
    placeholderFactoryId: '请输入工位名称',
    placeholderLineId: '请输入线体名称',
    alarmNum: '报警代码',
    alarmLevel: '报警级别',
    alarmText: '报警文本',
    alarmAddRule: '报警地址',
    supplierNum: '供应商编号',
    supplierNam: '供应商名称',
    isDisable: '是否禁用',
    alarmNumPlaceholder: '请输入报警代码',
    alarmLevelPlaceholder: '请输入报警级别',
    alarmTextPlaceholder: '请输入报警文本',
    alarmAddRulePlaceholder: '请输入报警地址',
    supplierNumPlaceholder: '请输入供应商编号',
    supplierNamPlaceholder: '请输入供应商名称',
    digitlengthplaceholder6: '请输入6位以内数字或英文',
    digitlengthplaceholder0: '请输入6位以内数字',
    alarmNumNotNull: '报警代码不能为空',
    alarmLevelNotNull: '报警级别不能为空',
    alarmTextlNotNull: '报警文本不能为空',
    alarmAddRuleNotNull: '报警地址不能为空',
    supplierNumNotNull: '供应商编号不能为空',
    supplierNamlNotNull: '供应商名称不能为空',
    disableValue1: 1, // 禁用
    inDisableValue1: 0, // 未禁用
    disableText1: '是',
    inDisableText1: '否'
  },
  HMICraftConfig: {
    title: 'HMI工艺文件配置',
    listTitle: 'HMI工艺文件配置'
  },

  PerGroup: {
    title: '班组字典',
    groupId: '班组编号',
    groupName: '班组名称',
    ngroupId: '班组编号不能为空',
    ngroupName: '班组名称不能为空',
    pgroupId: '请输入班组编号',
    pgroupName: '请输入班组名称'

  },
  PerGroupUser: {
    title: '班组人员分配',
    userId: '人员编号',
    isThisGroup: '是否本班',
    assignuser: '人员分配',
    assignsuccess: '分配成功',
    userName: '人员姓名'
  },
  MacMachAlarmOp: {
    title: '报警工位明细',
    listTitle: '报警工位明细列表',
    comboxOpId: '请选择工位号',
    alarmDetailNum: '报警明细代码',
    supplierNum: '供应商编号',
    opId: '工位号',
    alarmLevel: '报警级别',
    alarmText: '报警文本',
    alarmAdd: '报警地址',
    alarmDetailNumPlaceholder: '请输入报警明细代码',
    supplierNumPlaceholder: '请输入供应商编号',
    opIdPlaceholder: '请输入工位号',
    alarmLevelPlaceholder: '请输入报警级别',
    alarmTextPlaceholder: '请输入报警文本',
    alarmAddPlaceholder: '请输入报警地址',
    digitlengthplaceholder6: '请输入6位以内数字',
    alarmDetailNumNotNull: '报警明细代码不能为空',
    supplierNumNotNull: '供应商编号不能为空',
    opIdNotNull: '工位号不能为空',
    alarmLevelNotNull: '报警级别不能为空',
    alarmTextlNotNull: '报警文本不能为空',
    alarmAddRuleNotNull: '报警地址不能为空'
  },
  CraTechFactoryBom: {
    title: '工厂BOM配置',
    copy: '复制',
    delBoms: '批量删除',
    bomList: '物料列表',
    id: 'ID',
    factoryId: '工厂编号',
    lineId: '线体编号',
    taskId: '任务ID',
    taskName: '任务名称',
    taskQuantity: '任务数量',
    opId: '工位号',
    platformId: '平台号',
    engineTypeLittle: '机种号',
    engineType: '机型号',
    assemblyCode: '组件编码',
    assemblyName: '组件描述',
    supplier: '供应商',
    consumeQuantity: '消耗数量',
    isScanning: '是否扫描',
    isMainMaterial: '是否主物料',
    operateTime: '操作时间'
  },
  PerUser: {
    title: '人员配置',
    userId: '用户编号',
    userName: '用户名称',
    userPassword: '用户密码',
    searchId: '请输入用户编号',
    searchName: '请输入用户名称',
    searchDept: '请选择部门',
    endpassword: '请输入密码',
    makepassword: '请确认密码',
    userinfoplaceholder: '请输入用户信息',
    role: '角色名称',
    userList: '用户列表',
    assignedstatus: '角色分配',
    checkuserid: '检查用户ID',
    resetpassword: '重置密码',
    checksuccess: '用户名可用',
    checkfail: '用户名重复',
    useridlengthplaceholder: '长度在 5 到 10 个字符之间',
    usernamelengthplaceholder: '长度在 20 个字符以内',
    assignlistselectplaceholder: '请为当前用户选择至少一个角色',
    makeSurePassword: '确认密码',
    postionId: '数据权限',
    department: '部门',
    chooseRole: '页面访问权限',
    chooseUserIcon: '上传头像',
    choose: '请选择',
    user: '用户',
    person: '人员',
    isUser: '用户类型',
    inconsistentPasswords: '两次输入密码不一致',
    assignedStatusSuccess: '角色分配成功',
    assignedStatusFail: '角色分配失败',
    resetpassword1: '重置成功'
  },
  PerRole: {
    title: '角色配置',
    roleId: '角色编号',
    roleName: '角色名称',
    roleDesc: '角色描述',
    searchCode: '请输入角色编号',
    searchName: '请输入角色名称',
    searchDesc: '请输入角色描述',
    roleinfoplaceholder: '请输入角色信息',
    authority: '权限',
    assignedstatus: '权限分配',
    authorityId: '权限编号',
    authorityName: '权限名称',
    isrelatemenu: '权限关联',
    authoritysearch: '请输入权限名称',
    resourcename: '权限资源',
    checkroleid: '检查角色ID',
    checksuccess: '角色名可用',
    checkfail: '角色名重复',
    roleidlengthplaceholder: '长度在 4 到 10 个字符之间',
    rolenamelengthplaceholder: '长度在 20 个字符以内',
    assignlistselectplaceholder: '请为当前角色至少分配一个权限'
  },
  PerStruture: {
    title: '部门配置',
    deptName: '部门名称',
    deptDesc: '部门描述',
    deptParentName: '上级部门',
    deptNamePlaceholder: '请输入部门名称',
    deptDescPlaceholder: '请输入部门描述',
    deptNamelengthplaceholder: '部门名称的字符长度不能超过50',
    deptDesclengthplaceholder: '部门描述的字符长度不能超过50',
    deptNameNotNull: '部门名称不能为空',
    deptDescNotNull: '部门描述不能为空',
    rootSector: '根部门'
  },
  CraTechGuarantee: {
    title: '质保订单管理'
  },
  QuaRepDataBarcode: {
    title: '批次质量信息查询',
    // title: '物料数据查询',
    timeValueWarningMessage: '请输入时间查询条件',
    lineIdWarningMessage: '请输入线体查询条件',
    placeholderStart: '操作开始时间',
    rangeSeparatoe: '至',
    placeholderEnd: '操作结束时间',
    factoryId: '工厂编号',
    factoryName: '工厂名称',
    lineId: '线体编号',
    lineName: '线体名称',
    opName: '工位名称',
    placeholderFactoryId: '请输入工厂名称',
    placeholderLineId: '请输入线体名称',
    placeholderOpId: '请输入工位名称',
    placeholderEngineType: '请输入机型',
    placeholderEngineTypeLittle: '请输入机种号',
    placeholderPlatformId: '请输入TM机种号',
    placeholderTagValue: '请输入实际码',
    placeholderProductIdStart: '请输入起始序列号',
    placeholderProductIdEnd: '请输入结束序列号',
    isMainMaterial: '是否主物料',
    mainMaterial: '主物料',
    pickerOptionsShortcutsText1: '最近一周',
    pickerOptionsShortcutsText2: '最近一个月',
    pickerOptionsShortcutsText3: '最近三个月',
    titlein: '批次质量详细信息',
    operateTime: '操作时间',
    tagValue: '实际码',
    conditionShow: '查询',
    engineTypeLittle: '机种号',
    platformId: '平台号',
    engineType: '机型号',
    productId: '流水号',
    subProductId: '分线序列号',
    productIdStart: '起始序列号',
    productIdEnd: '结束序列号',
    decisionvalue: '判定值',
    opId: '工位编号',
    particular: '详细',
    operation: '操作',
    Qualitydetails: '质量详细信息',
    assemblyCode: '组件编码',
    assemblyName: '组件名称',
    barcodeName: '物料名称',
    orderNum: '订单号',
    placeholderOrderNum: '请输入订单号'
  },
  SysMenuSet: {
    systemMenu: '系统菜单',
    subSystemMenu: '子系统菜单',
    menuId: '菜单编号',
    menuName: '菜单名称',
    menuUrl: '链接地址',
    menuIcon: '菜单样式',
    menuParentId: '菜单父Id',
    menuOrder: '菜单排序',
    isLeaf: '是否叶子节点',
    menuIdCannotBeEmpty: '菜单ID不能为空',
    MenNameCannotBeEmpty: '菜单名称不能为空',
    pleaseEnterTheMenuID: '请输入菜单ID',
    pleaseEnterTheMenuName: '请输入菜单名称',
    pleaseEnterTheMenuParentID: '请输入菜单父ID',
    pleaseEnterTheMenuOrder: '请输入菜单排序',
    pleaseEnterTheisLeaf: '请输入是否叶子节点',
    pleaseEnterTheMenuUrl: '请输入链接地址'
  },
  QmProdQualityDataWork: {
    searchQualitydate: '质量数据查询',
    date: '日期',
    exportExcel: '导出Excel',
    unlimitedDate: '无日期限制',
    startTime: '开始时间',
    endTime: '结束时间',
    chooseStartTime: '请选择开始时间',
    chooseEndTime: '请选择结束时间',
    advancedQuery: '高级查询',
    productId: '流水号',
    searchProductIdStart: '请输入开始序列号',
    searchProductIdEnd: '请输入结束序列号',
    engineType: '机型号',
    searchEngineType: '请输入机型号',
    opId: '工位号',
    searchOpId: '请输入工位号',
    engineTypeLittle: '机种号',
    searchEngineTypeLittle: '请输入机种号',
    lineId: '线体编号',
    searchLineId: '请输入线体编号',
    orderNum: '计划号',
    shiftCode: '班次代码',
    trayNumber: '托盘号',
    platformId: '平台号',
    tagValue: '测量值',
    isOk: '总合格标志',
    searchIsOk: '请选择总合格标志',
    isGoodbad: '分合格标志',
    measureUnit: '测量单位',
    expectedValue: '理论值',
    upperlimitValue: '上限值',
    lowerlimitValue: '下限值',
    columnPostion: '列位置',
    columnSort: '列内排序',
    operateTime: '操作时间'
  },
  BaMachShift: {
    title: '班次管理'
  },
  operation: {
    title: '工位管理页面',
    searchId: '请输入工位编号',
    searchName: '请输入工位名称',
    proceduceid: '工序号',
    optypename: '工位类型',
    orderselectname: '订单选择',
    isserverinteractionname: '服务器交互',
    messageserverurl: '消息转送服务器URL',
    opcpartitionid: 'OPC服务器URL',
    opcclientid: 'OPC客户端编号',
    opidipaddress: '工位网卡MAC地址',
    proceduceidplaceholder: '请输入工序号',
    optypenameplaceholder: '请选择工位类型',
    messageserverurlplaceholder: '请输入消息转送服务器URL',
    opcpartitionidplaceholder: '请输入OPC服务器URL',
    opcclientidplaceholder: '请输入OPC客户端编号',
    opidipaddressplaceholder: '请输入工位网卡MAC地址',
    opcclientidtypeholder: '请输入数字',
    urlplaceholder: 'URL地址不合法',
    ipplaceholder: 'IP地址不合法',
    checkopid: '检查工位ID',
    checksuccess: '工位编号可用',
    checkfail: '工位编号重复',
    opidlengthplaceholder: '长度在 5 到 10 个字符之间',
    opnamelengthplaceholder: '长度在 50 个字符以内',
    lengthplaceholder: '输入内容过长'
  },
  product: {
    // title: '产品型号字典',
    title: '产品型号管理',
    buttonColumn: '操作',
    buttonDisable: '禁用',
    buttonEnable: '启用',
    buttonSelect: '查询',
    buttonCreate: '新建',
    buttonUpdate: '修改',
    buttonDelete: '删除',
    buttonSubmit: '确定',
    buttonCancel: '取消',
    isDisable: '是否禁用',
    factoryId: '工厂名称',
    lineId: '线体名称',
    productModel: '机型号',
    platformId: '平台号',
    engineTypeLittle: '机种号',
    version: '版本号',
    remark: '备注',
    placeholderFactoryId: '请输入工厂名称',
    placeholderLineId: '请输入线体名称',
    placeholderProductModel: '请输入产品型号',
    placeholderPlatformId: '请输入平台号',
    placeholderEngineTypeLittle: '请输入机种号',
    placeholderRemark: '请输入备注',
    confirmtextTitle: '提示',
    confirmtext: '确认提交数据？',
    confirmtextCancel: '取消',
    warningMsg: '请选中操作行',
    searchmodel: '请输入产品型号',
    searchname: '请输入产品名称',
    ismainline: '是否主线',
    productlengthplaceholder: '输入内容过长',
    checkproductmodel: '检查产品型号',
    checksuccess: '产品型号可用',
    checkfail: '产品型号重复'
  },
  AnTechBasicdata: {
    title: '安东配置管理',
    buttonCreate: '新建',
    buttonDelete: '删除',
    buttonUpdate: '编辑',
    placeholderFactoryId: '请输入工厂名称',
    placeholderLineId: '请输入线体名称',
    placeholderOpName: '请输入工位号',
    placeholderAnCode: '请输入安东类型代码',
    placeholderAnCodeDescription: '请选择安东类型',
    placeholderAnLevelDescription: '请输入安东等级',
    placeholderAnContent: '请输入安东类型描述',
    placeholderColor: '请输入颜色',
    id: '主键ID',
    factoryId: '工厂名称',
    lineId: '线体名称',
    opName: '工位号',
    opStation: '工位名称',
    anCode: '安东类型代码',
    anCodeDescription: '安东类型 ',
    anLevelDescription: '安东等级',
    anContent: '安东类型描述',
    color: '颜色',
    isDisabled: '是否禁用',
    version: '版本号',
    confirmtextTitle: '提示',
    confirmtext: '确认提交数据？',
    confirmtextCancel: '取消',
    warningMsg: '请选中操作行',
    pickerOptionsShortcutsText1: '最近一周',
    pickerOptionsShortcutsText2: '最近一个月',
    pickerOptionsShortcutsText3: '最近三个月'
  },
  AnTechHistoryData: {
    timeValueWarningMessage: '请输入时间查询条件',
    title: '安东信息查询',
    placeholderStart: '解除开始时间',
    rangeSeparatoe: '至',
    placeholderEnd: '解除结束时间',
    placeholderFactoryId: '请输入工厂名称',
    placeholderLineId: '请输入线体名称',
    placeholderOpId: '请输入工位号',
    placeholderAnCode: '请输入安东类型代码',
    opId: '工位号',
    opName: '工位名称',
    anCode: '安东类型代码',
    anCodeType: '安东类型',
    anCodeDescription: '安东类型描述',
    anContent: '安东内容',
    productId: '流水号',
    orderNum: '计划号',
    platformId: '平台号',
    engineType: '机型号',
    engineTypeLittle: '机种号',
    factoryId: '工厂名称',
    lineId: '线体名称',
    orderNumber: '订单号',
    callUserId: '呼叫人ID',
    callUserName: '呼叫人姓名',
    callInTime: '呼叫时间',
    callOutTime: '解除时间',
    pickerOptionsShortcutsText1: '最近一周',
    pickerOptionsShortcutsText2: '最近一个月',
    pickerOptionsShortcutsText3: '最近三个月'
  },
  QuaRepDataModel: {
    timeValueWarningMessage: '请输入时间查询条件',
    engineTypeWarningMessage: '请输入机型查询条件',
    title: '机种质量信息查询',
    placeholderStart: '开始时间',
    rangeSeparatoe: '至',
    placeholderEnd: '结束时间',
    placeholderFactoryId: '请输入工厂名称',
    placeholderLineId: '请输入线体名称',
    placeholderOpId: '请输入工位号',
    placeholderOpName: '请输入工位名称',
    placeholderPlatformId: '请输入TM机种号',
    placeholderProductId: '请输入流水号',
    placeholderEngineType: '请输入机型号',
    placeholderEngineTypeLittle: '请输入机种号',
    buttonColumn: '操作',
    buttonSelect: '查询',
    buttonSubmit: '确定',
    buttonCancel: '取消',
    id: '主键ID',
    factoryId: '工厂名称',
    lineId: '线体名称',
    productId: '流水号',
    tagId: 'tagId',
    orderNum: '计划号',
    shiftCode: '班次代码',
    trayNumber: '托盘号',
    platformId: '平台号',
    platformName: '平台号',
    engineType: '机型号',
    engineTypeLittle: '机种号',
    tagValue: '测量值',
    isOk: '总合格标志',
    isGoodbad: '分合格标志',
    measureUnit: '测量单位',
    measurepPosition: '测量位置',
    measureItem: '测量项目',
    opId: '工位号',
    opName: '工位名称',
    expectedValue: '理论值',
    upperlimitValue: '上限值',
    lowerlimitValue: '下限值',
    columnPostion: '列位置',
    columnSort: '列内排序',
    operateTime: '操作时间',
    isDisabled: '是否禁用',
    version: '版本号',
    dialogTitle: '详细信息',
    pickerOptionsShortcutsText1: '最近一周',
    pickerOptionsShortcutsText2: '最近一个月',
    pickerOptionsShortcutsText3: '最近三个月',
    fileContents: '文件内容'
  },
  MacMachStation: {
    title: '工位配置',
    treeTitle: '工厂建模',
    infactoryId: '工厂名称',
    inlineId: '线体名称',
    orderselectname: '选择订单权限',
    inopId: '工位号',
    inopName: '工位名称',
    opName: '工位名称',
    save: '保存',
    nosave: '不保存',
    HavePrinter: '有',
    noHavePrinter: '无',
    CannotSelectOrder: '不能选择订单权限',
    CanSelectOrder: '可以选择订单权限',
    orderSelectIdSel: '选择订单权限',
    porderSelectIdSel: '请选择订单权限',
    plcIp: 'PLC-IP地址',
    pplcIp: '请输入PLC-IP地址',
    ipcIp: 'IPC-IP地址',
    pipcIp: '请输入PLC-IP地址',
    opNameNotNull: '工位名称不能为空',
    produceNum: '工序号不能为空',
    PLCIPNotNull: 'PLC-IP地址不能为空',
    IPCIPNotNull: 'IPC-IP地址不能为空',
    OnlineStation: '上线工位',
    OnlineRepairStation: '上线返修工位',
    GeneralStation: '普通工位',
    RepairUaLWorkStation: '返修上下线工位',
    IsQualifiedOfflineStation: '合格不合格下线工位',
    QualifiedOfflineStation: '合格下线工位',
    UnqualifiedOfflineStation: '不合格下线工位',
    pmonitoringPropertyCode: '请输入监控属性代码',
    isHavePrinter: '是否有打印机',
    popTypeId: '请选择工位类型',
    isMesEnabled: '是否启用MES'
  },
  QuaRepDataWorkNew: {
    okFlag: '合格标志',
    timeValueWarningMessage: '请输入时间查询条件',
    opIdWarningMessage: '请输入工位查询条件',
    // title: '质量数据查询',
    title: '工序质量信息查询',
    placeholderStart: '开始时间',
    rangeSeparatoe: '至',
    placeholderEnd: '结束时间',
    placeholderFactoryId: '请输入工厂名称',
    placeholderLineId: '请输入线体名称',
    placeholderOpId: '请输入工位号',
    placeholderOpName: '请输入工位名称',
    placeholderPlatformId: '请输入TM机种号',
    placeholderProductId: '请输入流水号',
    placeholderEngineType: '请输入机型号',
    placeholderEngineTypeLittle: '请输入机种号',
    buttonColumn: '操作',
    buttonSelect: '查询',
    buttonSubmit: '确定',
    buttonCancel: '取消',
    id: '主键ID',
    factoryId: '工厂名称',
    lineId: '线体名称',
    productId: '流水号',
    tagId: 'tagId',
    orderNum: '计划号',
    shiftCode: '班次代码',
    trayNumber: '托盘号',
    platformId: '平台号',
    platformName: '平台号',
    engineType: '机型号',
    engineTypeLittle: '机种号',
    tagValue: '测量值',
    isOk: '总合格标志',
    isGoodbad: '分合格标志',
    measureUnit: '测量单位',
    measurepPosition: '测量位置',
    measureItem: '测量项目',
    opId: '工位号',
    opName: '工位名称',
    expectedValue: '理论值',
    upperlimitValue: '上限值',
    lowerlimitValue: '下限值',
    columnPostion: '列位置',
    columnSort: '列内排序',
    operateTime: '操作时间',
    isDisabled: '是否禁用',
    version: '版本号',
    dialogTitle: '详细信息',
    pickerOptionsShortcutsText1: '最近一周',
    pickerOptionsShortcutsText2: '最近一个月',
    pickerOptionsShortcutsText3: '最近三个月'
  },
  MacRawData: {
    title: '原始数据配置',
    placeholderFactoryId: '请输入工厂编号',
    placeholderLineId: '请输入线体编号',
    placeholderOpId: '请输入工位号',
    placeholderFactoryName: '请输入工厂名称',
    placeholderLineName: '请输入线体名称',
    placeholderOpName: '请输入工位名称',
    column: '操作',
    search: '查询',
    create: '新建',
    modify: '编辑',
    delete: '删除',
    sure: '确 定',
    cancel: '取 消',
    factoryId: '工厂名称',
    lineId: '线体名称',
    tagId: 'tagId',
    opId: '工位名称',
    dataSources: '数据来源',
    plcip: 'plc ip',
    tagTypeId: '数据类型代码',
    tagLong: '数据长度',
    dbName: '数据DB',
    tagType: '数据类型',
    variableAddress: '变量地址',
    variableOthers: '变量其他',
    columnPosition: '列位置',
    measuringPosition: '测量位置',
    measuringItems: '测量项目',
    measuringUnit: '测量单位',
    variableTypeCode: '变量类型代码',
    variableTypeName: '变量类型名称',
    tagAdr: '变量详细地址',
    isEnabled: '是否启用',
    variableCharacteristics: '变量特点',
    variableSort: '变量排序',
    monitoringPropertyCode: '监控属性代码',
    quality: '是否为质量数据',
    placeholdertagId: '请输入tagId',
    placeholderdataSources: '请输入数据来源',
    placeholderplcip: '请输入plc ip',
    placeholdertagTypeId: '请输入数据类型代码',
    placeholdertagLong: '请输入数据长度',
    placeholderdbName: '请输入数据DB',
    placeholdertagType: '请输入数据类型',
    placeholdervariableAddress: '请输入变量地址',
    placeholdervariableOthers: '请输入变量其他',
    placeholdercolumnPosition: '请输入列位置',
    placeholdermeasuringPosition: '请输入测量位置',
    placeholdermeasuringItems: '请输入测量项目',
    placeholdermeasuringUnit: '请输入测量单位',
    placeholdervariableTypeCode: '请输入变量类型代码',
    placeholdervariableTypeName: '请输入变量类型名称',
    placeholdertagAdr: '请输入变量详细地址',
    placeholdervariableCharacteristics: '请输入变量特点',
    placeholdervariableSort: '请输入变量排序',
    placeholdermonitoringPropertyCode: '请输入监控属性代码',
    yes: '是',
    no: '否',
    rulelength50: '长度不能超过50',
    rulelength20: '长度不能超过20',
    rulelength12: '长度不能超过12',
    checktagid: '检查tagid',
    checkfail: '该tagid已被占用',
    checksuccess: '该tagid可用',
    searchCode: '请输入tagid',
    rulenumber: '请输入数字值',
    rulenull: '内容不可为空',
    ruletagIdnull: '标识符不能为空',
    rulefactoryIdnull: '工厂编号不能为空',
    rulelineIdnull: '线体编号不能为空',
    ruleopIdnull: '工位号不能为空',
    ruledataSourcesnull: '数据来源不能为空',
    ruleipPlcnull: 'plc ip不能为空',
    ruletagTypeIdnull: '数据类型代码不能为空',
    ruletagLongnull: '数据长度不能为空',
    ruledbNamenull: '数据DB不能为空',
    ruletagTypenull: '数据类型不能为空',
    rulevariableAddressnull: '变量地址不能为空',
    rulevariableOthersnull: '变量其他格式不正确',
    rulecolumnPositionnull: '列位置不能为空',
    rulemeasuringPositionnull: '测量位置不能为空',
    rulemeasuringItemsnull: '测量项目不能为空',
    rulemeasuringUnitnull: '测量单位不能为空',
    rulevariableTypeCodenull: '变量类型代码不能为空',
    rulevariableTypeNamenull: '变量类型名称不能为空',
    ruletagAdrnull: '变量详细地址不能为空',
    rulevariableCharacteristicsnull: '变量特点不能为空',
    rulevariableSortnull: '变量排序不能为空',
    rulemonitoringPropertyCodenull: '监控属性代码不能为空',
    deleteDialog: '此操作将永久删除该数据, 是否继续?',
    baseBeatnull: '基准节拍不能为空',
    maxLength5: '请输入数字0~99999',
    baseBeat: '基准节拍'

  },
  QuaRepQuality: {
    title: '质量数据范围配置',
    placeholderFactoryId: '请输入工厂编号',
    placeholderLineId: '请输入线体编号',
    placeholderOpId: '请输入工位号',
    placeholderFactoryName: '请输入工厂名称',
    placeholderLineName: '请输入线体名称',
    placeholderOpName: '请输入工位名称',
    placeholderEngineType: '请输入机型号',
    placeholderEngineTypeLittle: '请输入机种号',
    placeholderPlatformId: '请输入TM机种号',
    column: '操作',
    search: '查询',
    create: '新建',
    modify: '编辑',
    delete: '删除',
    sure: '确 定',
    cancel: '取 消',
    Id: 'id',
    tagId: '对应原始数据tagId',
    factoryId: '工厂名称',
    lineId: '线体名称',
    opId: '工位名称',
    engineType: '机型号',
    engineTypeLittle: '机种号',
    platformId: '平台号',
    upperlimitValue: '最大值',
    lowerlimitValue: '最小值',
    expectedValue: '理论值',
    flagId: '位置标号',
    updateUserName: '编辑者',
    updateDate: '编辑时间',
    version: '版本号',
    isEnabled: '是否启用',
    yes: '是',
    no: '否',
    conditionShow: '更多查询',
    searchtemplate: '请选择模板',
    rulenumber: '请输入数字值',
    rulelength12: '长度不能超过12',
    rulelength50: '长度不能超过50'
  },
  SysWorkCalendar: {
    title: '工作日历配置',
    factoryName: '工厂名称',
    lineName: '线体名称',
    placeholderFactoryName: '请输入工厂名称',
    placeholderLineName: '请输入线体名称',
    year: '年',
    month: '月',
    checkdata: '请选择日期',
    selectYear: '选择年',
    selectMonth: '选择月',
    rest: '假',
    holiday: '节假日',
    holidayDate: '节假日日期',
    setHoliday: '此操作将此日期设定为假期, 是否继续?',
    setSuccess: '设定成功',
    set: '设定',
    cancelSet: '已取消设定'
  },
  SysWorkCalendarTips: {
    title: '工作日历配置提示',
    userId: '人员编号',
    userName: '人员姓名',
    mailAdr: '电子邮件地址',
    mailDetails: '电子邮件内容',
    mailTitle: '电子邮件标题',
    mailType: '电子邮件类型',
    mailParticular: '电子邮件详细说明',
    isEnabled: '是否启用',
    sendDatetime: '发送邮件时间',
    ruleuserNamesnull: '人员姓名不能为空',
    rulemailAdrsnull: '邮箱地址不能为空',
    rulemailDetailsnull: '邮件内容不能为空',
    rulemailTypesnull: '邮件类型不能为空',
    rulemailTitlesnull: '邮件标题不能为空',
    rulemailParticularsnull: '邮件详细说明不能为空',
    rulesendDatetimenull: '发送时间不能为空',
    rulelength20: '长度不能超过20',
    rulelength50: '长度不能超过50',
    rulelength100: '长度不能超过100',
    placeholderUserName: '请输入人员姓名',
    placeholderMailAdr: '请输入邮箱地址',
    placeholderMailDetails: '请输入邮箱内容',
    placeholderSendTime: '请输入发送时间',
    placeholderMailTitle: '请输入电子邮件标题',
    placeholderMailType: '请输入电子邮件类型',
    placeholderMailParticular: '请输入电子邮件详细说明',
    changeStatesSuccess: '修改启用状态成功',
    changeStatesFailure: '修改启用状态失败'
  },
  PerUserMail: {
    title: '人员邮件字典',
    id: '主键',
    userId: '人员编号',
    userName: '人员姓名',
    deptName: '部门名称',
    deptId: '部门编号',
    mailAdr: '邮箱地址',
    isEnabled: '是否启用',
    rulenumber: '请输入数字值',
    rulelength50: '长度不能超过50',
    rulelength20: '长度不能超过20',
    rulenull: '内容不可为空',
    ruledeptIdnull: '部门编号不能为空',
    ruledeptNamenull: '部门名称不能为空',
    ruleuserIdnull: '人员编号不能为空',
    ruleuserNamenull: '人员姓名不能为空',
    rulemailAdrnull: '邮箱地址不能为空',
    rulemailAdr: '邮箱格式不正确',
    placeholderDeptId: '请输入部门编号',
    placeholderDeptName: '请输入部门名称',
    placeholderUserName: '请输入人员姓名',
    placeholderMailAdr: '请输入邮箱地址'
  },
  PerCron: {
    title: '定时任务字典',
    isEnabled: '是否启用',
    cronName: '定时任务名称',
    cronValue: '定时任务表达式',
    placeholdercronName: '请输入定时任务名称',
    placeholdercronValue: '请输入定时任务表达式',
    rulecronNamenull: '定时任务名称不能为空',
    rulecronValuenull: '定时任务表达式不能为空',
    rulelength50: '长度不能超过50',
    rulelength100: '长度不能超过100'
  },
  workshift: {
    title: '班次管理页面',
    workshiftid: '班次编号',
    workshiftname: '班次名称',
    searchid: '请输入班次编号',
    searchname: '请输入班次名称',
    workshiftstarttime: '班次开始时间',
    workshiftendtime: '班次结束时间',
    forbiddenname: '禁用',
    checktimefail: '请检查时间是否正确',
    checkforbiddenfail: '至少需要启用一条班次',
    attention1: '1、已启用的班次起止时间不得有交叉',
    attention2: '2、至少需要有一轮班次处于启用状态'
  },
  program: {
    // title: '程序号字典',
    title: '程序号管理',
    buttonSelect: '查询',
    buttonCreate: '新建',
    buttonUpdate: '修改',
    buttonDelete: '删除',
    buttonSubmit: '确定',
    buttonCancel: '取消',
    placeholderLineId: '请输入线体名称',
    placeholderFactoryId: '请输入工厂名称',
    placeholderOpStation: '请输入工位号',
    placeholderOpName: '请输入工位名称',
    placeholderProduceNum: '请输入程序号',
    placeholderNowproduceNum: '请输入现有程序号',
    placeholderPlatformId: '请输入平台号',
    placeholderEngineType: '请输入机型号',
    placeholderProductId: '请输入流水号',
    placeholderEngineTypeLittle: '请输入机种号',
    factoryId: '工厂名称',
    lineId: '线体名称',
    opStation: '工位号',
    opName: '工位名称',
    programId: '程序号ID',
    produceNum: '程序号',
    nowproduceNum: '现有程序号',
    version: '版本号',
    confirmtextTitle: '提示',
    confirmtext: '确认提交数据？',
    confirmtextCancel: '取消',
    warningMsg: '请选中操作行',

    searchid: '请输入工位名称',
    searchname: '请输入程序号名称',
    assignedstatus: '工步配置状态',
    checkid: '检查程序号ID',
    checksuccess: '程序号可用',
    checkfail: '程序号重复',
    notrelate: '程序号无关',
    relate: '程序号相关',
    caution: '已自动过滤程序号无关工步',
    programIdplaceholder: '请输入0到99的数字'
  },
  programconfig: {
    title: '机型程序号配置',
    configprogram: '配置',
    buttonSelect: '查询',
    buttonCreate: '新建',
    buttonUpdate: '修改',
    buttonDelete: '删除',
    buttonSubmit: '确定',
    buttonCancel: '取消',
    confirmtextTitle: '提示',
    confirmtext: '确认提交数据？',
    confirmtextCancel: '取消',
    warningMsg: '请选中操作行',
    placeholderFactoryId: '请输入工厂名称',
    placeholderLineId: '请输入线体名称',
    placeholderOpId: '请输入工位号',
    placeholderproduceNum: '请输入程序号',
    placeholderEngineType: '请输入机型号',
    factoryId: '工厂名称',
    engineType: '机型号',
    lineId: '线体名称',
    opId: '工位号',
    opName: '工位名称',
    produceNum: '程序号',
    version: '版本号',
    searchid: '请输入工位号名称',
    searchname: '请输入产品型号',
    programIdplaceholder: '请配置一个程序号'
  },
  action: {
    title: '动作管理页面',
    searchid: '请输入动作编号',
    searchname: '请输入动作名称',
    steprespond: '工步响应目标',
    isrepareselectaction: '是否允许返修选择动作',
    isallowactionredo: '是否允许动作重做',
    actionunit: '动作单位',
    actionextremumvalue: '动作极值',
    sleeveid: '套筒号',
    actioncomponentid: '动作组件编号',
    issavedata: '是否保存数据',
    stepRespondIdplaceholder: '请选择工步响应目标',
    actionunitplaceholder: '请选择动作单位',
    minholder: '请输入最小值',
    maxholder: '请输入最大值',
    sleeveidplaceholder: '请输入套筒号',
    actioncomponentidplaceholder: '请输入动作组件编号',
    numberholder: '请输入小于99的数字',
    checkid: '检查动作编号',
    checksuccess: '动作编号可用',
    checkfail: '动作编号不可用'
  },
  step: {
    searchopid: '请输入工位编号',
    searchid: '请输入工步编号',
    searchname: '请输入工步名称',
    steppicture: '工步图标',
    stepurl: '工步图片',
    isrelatetoprogram: '是否与程序号相关',
    isrepareselectstep: '是否允许返修选择工步',
    forbidden: '禁用',
    assignedstatus: '动作配置状态',
    numberholder: '请输入数字',
    lengthplaceholder: '长度在 20 个字符以内',
    actionassignplaceholder: '请至少选择一个动作',
    stepurlplaceholder: '请输入工步图片地址',
    checkid: '检查工步编号',
    checksuccess: '工步编号可用',
    checkfail: '工步编号不可用'
  },
  plan: {
    title: '计划管理',
    // title: '计划制定',
    planfrom: '计划来源',
    searchid: '请输入订单号',
    searchname: '请选择产品型号',
    searchenginetypelittle: '请选择机种号',
    searchenginetype: '请选择机型号',
    ordercount: '订单数量',
    planstarttime: '计划开始时间',
    planendtime: '计划结束时间',
    datemark: '至',
    actualstarttime: '实际开始时间',
    actualendtime: '实际结束时间',
    plandate: '计划开始时间',
    ordersequence: '订单排序',
    ordersourcename: '订单来源',
    orderstatusname: '订单状态',
    schedulingornot: '是否排产',
    repairordername: '返修订单',
    ordercountplaceholder: '请输入订单数量',
    ordersequenceplaceholder: '请输入订单排序',
    orderstatusnameplaceholder: '请选择订单状态',
    plandateplaceholder: '请选择计划时间',
    lengthplaceholder: '输入内容长度过长',
    numberplaceholder: '请输入数字',
    checkid: '检查订单号',
    checksuccess: '订单号可用',
    checkfail: '订单号不可用',
    selectlineid: '请选择线体名称',
    selectplatformid: '请选择平台号',
    sort: '排序',
    selectfactoryid: '请选择工厂名称',
    sortdown: '订单排序下降',
    sortup: '订单排序上升',
    orderissued: '任务下达成功',
    orderfreeze: '任务冻结成功',
    orderclose: '任务关闭成功',
    insertPlan: '是否插单',
    searchinsertPlan: '请选择是否插单',
    insertDate: '下发时间'
  },
  // 任务接受
  planreceive: {

    title: '任务接受',
    ordername: 'ERP任务名称',
    ordernumber: 'ERP任务数量',
    assemblyNum: 'ERP任务机型号',
    startdata: 'ERP任务计划开始时间'
  },
  MacEquipmentPlan: {
    title: '设备保养',
    maintainId: '维护计划编号',
    maintainIdenter: '请输入维护计划编号',
    datestart: '维护开始时间',
    datestartenter: '请选择维护开始时间',
    dateend: '维护结束时间',
    dateendenter: '请选择维护结束时间',
    maintenancetime: '维护时间',
    maintainperiod: '维护计划生成周期',
    maintainperiodenter: '请选择维护计划生成周期',
    lasttime: '计划上次维护时间',
    timingtask: '定时任务',
    delaytime: '请选择延迟时间',
    maintenancecontents: '维护内容',
    maintenancecontentsenter: '请选择维护内容（可多选）',
    maintenancecontentsInput: '请输入维护内容'
  },
  MacEquipmentOverhaul: {
    title: '设备检修信息查询',
    maintenanceplannumber: '保养计划号',
    maintainernumber: '保养者编号',
    maintainername: '保养者姓名',
    maintainernamePlaceholder: '请输入保养者姓名'
  },
  serialnumber: {
    title: '流水号管理页面',
    isgenerateproductmodel: '是否与机型相关',
    generatetype: '流水号生成方式',
    reserve: '备用'
  },
  subproduct: {
    title: '总成分总成匹配管理页面',
    subproductmodel: '分产品型号',
    mainline: '总装线',
    selecterror: '请选择不同产品进行匹配'
  },
  langselect: {
    switchsuccess: '语言切换成功',
    switchfail: '语言切换成功'
  },
  info: {
    selecterp: '请输入ERP任务号'
  },
  timeshow: {
    weekarray: [
      '星期日',
      '星期一',
      '星期二',
      '星期三',
      '星期四',
      '星期五',
      '星期六'
    ],
    titleformat: '{y}年{m}月{d}日 {a} {h}:{i}:{s}'
  },
  namenu: {
    menutitle: '目录'
  },
  hstitle: {
    logout: '退出'
  },
  page404: {
    homepage: '返回首页',
    describe: '数据不存在或没有访问权限！'
  },
  home: {
    title: '产量信息',
    buttontitle: '快速入口',
    factoryId: '工厂名称',
    lineId: '线体名称',
    produceDate: '生产日期',
    shiftCode: '班次代码',
    orderNum: 'ERP订单号',
    platformId: '平台号',
    engineTypeLittle: '机种号',
    engineType: '机型号',
    onlineCount: '上线数量',
    offlineCount: '下线数量',
    okCount: '合格数量',
    ngCount: '不合格数量',
    orderState: '订单状态',
    orderState0: '已创建',
    orderState1: '已下达',
    orderState2: '生产中',
    orderState3: '已冻结',
    orderState4: '已冻结',
    orderState5: '已关闭'
  },
  MacOperationStationData: {
    timeValueWarningMessage: '请输入时间查询条件',
    opIdWarningMessage: '请输入工位查询条件',
    placeholderStart: '操作开始时间',
    rangeSeparatoe: '至',
    placeholderEnd: '操作结束时间',
    pickerOptionsShortcutsText1: '最近一周',
    pickerOptionsShortcutsText2: '最近一个月',
    pickerOptionsShortcutsText3: '最近三个月',
    titleRepairParts: '返修件过站信息查询',
    titleCalibrationParts: '标定件过站信息查询',
    QuaRepDataModel: '机种质量信息查询',
    qmprodmeasuredatabarcode: '批次质量信息查询',
    placeholderFactoryId: '请输入工厂名称',
    placeholderLineId: '请输入线体名称',
    placeholderOpId: '请输入工位名称',
    id: 'ID',
    factoryId: '工厂名称',
    lineId: '线体名称',
    opId: '工位号',
    factoryName: '工厂名称',
    lineName: '线体名称',
    opName: '工位名称',
    productId: '流水号',
    orderNum: '订单号',
    shiftCode: '班次代码',
    trayNumber: '托盘号',
    operatorId: '操作工ID',
    platformId: '平台号',
    engineType: '机型号',
    engineTypeBig: '机种号',
    standardCycleTime: '标准时间',
    actualCycleTime: '实际时间',
    blockTime: '堵塞时间',
    freeTime: '空闲时间',
    inPlaceTime: '工件到位时间',
    productState: '工件状态',
    okFlag: '总合格标志',
    isDisable: '是否禁用',
    isFirstStop: '是否首次进站',
    operateTime: '操作时间',
    version: '版本号',
    // title: '过站信息显示',
    title: '过站信息查询',
    isFirstStopY: '是首次进站',
    isFirstStopN: '不是是首次进站',
    // FTTreport: 'FTT报表'
    FTTreport: '设备通过率分析'
  },
  SysPostionFactoryLine: {
    dataPermissionCoding: '数据权限编码',
    dataPermissionName: '数据权限名称',
    dataPermission: '数据权限',
    unselectedPosition: '未选中职位'
  },
  SysAuthorityCenter: {
    roleName: '角色名称',
    characterRendering: '角色描述',
    buttonPermissions: '按钮权限',
    unselectedRole: '未选中角色',
    AuthorityCenter: '权限中心'
  },
  MacNumberStatus: {
    title: '生产信息显示',
    numberstatus: '序列号状态',
    onlineTime: '上线时间',
    offlineTime: '下线时间',
    placeholdernumber: '请输入序列号',
    numberERP: '请在ERP任务号中输入数字'
  },
  ErrorProofResults: {
    errorProofInformationQuery: '防错信息查询',
    factoryName: '工厂名称',
    lineName: '线体名称',
    productId: '流水号',
    opName: '工位名称',
    shiftCode: '班次代码',
    trayNumber: '托盘号',
    platformId: '平台号',
    engineTypeLittle: '机种号',
    engineType: '机型号',
    isOk: '总合格标志',
    tagValue: '防错结果',
    measuringItems: '测量项目',
    isDisabled: '是否禁用',
    operateTime: '操作时间',
    startUsing: '启用',
    disable: '禁用'
  },
  RtProductTime: {
    title: '生产时间报表'
  },
  MacRtProductTakt: {
    title: '生产节拍'
  },
  MacRtMTTR: {
    title: 'MTTR图表',
    yFormatter: '（h/次）'
  },
  MacRtMTBF: {
    title: 'MTBF图表',
    yFormatter: '（h/次）'
  },
  RtXBarR: {
    title: 'Xbar-R管理图表',
    yBarFormatter: '',
    yRFormatter: '',
    measureItem: '数据类型',
    measureItemPlaceholder: '请输入数据类型',
    measureItemNotNull: '数据类型不为空'
  },
  MacRtEquipmentFault: {
    title: '设备故障率图表',
    yFormatter: ''
  },
  MacRtEquipmentMFault: {
    title: '周一设备故障率图表',
    yFormatter: '%'
  },
  MacRtSpeedRate: {
    title: '速度开动率图表',
    yFormatter: ''
  },
  MacRtTimeRate: {
    title: '时间开动率图表',
    yFormatter: ''
  },
  ProRepEquipmentUptime: {
    title: '设备开动率图表',
    yFormatter: ''
  },
  ProRepJPH: {
    JPHSelect: 'JPH查询',
    yFormatter: '台/小时'
  },
  QuaRepProductionP: {
    title: '不良品率'
  },
  MacRepPerformanceRunRrate: {
    title: '性能开动率图表'
  },
  MacRtOee: {
    // title: 'OEE图表'
    title: '设备OEE分析'
  },
  RtOperatingTime: {
    title: '开动时间图表'
  },
  MacRtLoadingTime: {
    title: '负荷时间图表'
  },
  MacRtRateEfficiency: {
    title: '净开动率图表'
  },
  QuaRepMsa: {
    title: 'MSA'
  },
  RtProductTakt: {
    // title: 'DTD生产节拍报表'
    title: '生产节拍报表'
  },
  MacPmProdOpMonitory: {
    //  title: '生产动态监控',
    title: '设备动态监控',
    editMode: '编辑模式',
    returnView: '返回视图',
    delete: '删除',
    opModify: '工位修改',
    op: '工位',
    opWidth: '宽度',
    opColor: '颜色',
    pleaseChoice: '请选择',
    moveSpeed: '光标速度',
    saveAll: '全部保存',
    new: '新建',
    slow: '精准',
    fast: '快速',
    text1: '设定速度后，点击工位',
    text2: '并使用键盘方向键调整位置',
    text3: '建议关闭左侧导航栏'
  },
  CraTechRoute: {
    factoryId: '工厂编号',
    factoryName: '工厂名称',
    lineId: '线体编码',
    opId: '工位号',
    opName: '工位名称',
    produceNum: '工序号',
    routeNum: '工艺路线编号',
    dialogTitle: '工艺路线配置编辑',
    // listSearchTitle: '工艺路线配置',
    listSearchTitle: '工艺路线配置',
    routeNumNotNull: '工艺路线编号不能为空',
    routeNumPlaceholder: '请输入工艺路线编号',
    digitlengthplaceholder10: '请输入10位以内数字',
    noStationInformation: '暂无剩余工位',
    stationPlaceholder: '请拖拽工位至此',
    routeNumRepeat: '工艺路线编号重复',
    engineType: '机型号',
    engineTypeNotNull: '机型号不能为空'
  },
  BaOperationLog: {
    operationLog: '日志LOG',
    updateUserName: '更新人',
    updateDate: '更新时间',
    czry: '请输入操作人员',
    cznr: '请输入操作内容',
    czryxm: '请输入操作人员姓名',
    rzcx: '日志管理'
  },
  SysExcelDownload: {
    fileName: '文件名',
    filePath: '文件路径',
    conditionJson: '查询条件',
    statusStr: '状态',
    insertDate: '生成时间',
    updateDate: '生成完成时间',
    insertUserId: '生成'
  },
  BaPerIndicatorLight: {
    title: 'HMI指示东配置',
    factoryName: '工厂名称',
    lineName: '线体名称',
    opName: '工位名称',
    placeholderFactoryName: '请输入工厂名称',
    placeholderLineName: '请输入线体名称',
    placeholderOpName: '请输入工位名称',
    isEnabled: '是否禁用',
    search: '查询',
    opname: '工位名称',
    opid: '工位编号',
    lightLabel: '指示东名称',
    placeholderlightLabel: '请输入指示东名称',
    create: '新建',
    cancel: '取消',
    sure: '确定',
    modify: '编辑',
    isDisable: '是否禁用',
    forbidden: '启用',
    notforbidden: '禁用',
    all: '全部',
    operation: '操作',
    delete: '删除',
    updateSuccess: '修改成功',
    updateSuccess1: '按钮权限修改成功',
    updateSuccess2: '数据权限修改成功',
    noResponseWarningMessage: '无符合查询条件数据',
    deleteConfirm: '此操作将永久删除该数据, 是否继续?',
    prompt: '提示',
    deleteSuccess: '删除成功',
    cancelDelete: '已取消删除',
    newSuccess: '新建成功',
    lightKey: '指示灯标识',
    placeholderlightKey: '请输入指示灯标识',
    factoryNamePlaceholder: '工厂名称不能为空！',
    lineNamePlaceholder: '线体名称不能为空!'
  },
  MacRepParameter: {
    macRepParameter: '设备台账',
    factoryName: '工厂名称',
    lineName: '线体名称',
    equipmentName: '设备名称',
    equipmentModel: '设备型号',
    supplier: '供应商',
    netIp: '入网Ip',
    updateUserName: '更新者姓名',
    updateDate: '更新时间',
    insertUserName: '插入者姓名',
    insertDate: '插入时间',
    pleaseEnterTheSupplier: '请输入供应商',
    pleaseEnterTheNetIp: '请输入入网Ip',
    pleaseEnterTheEquipmentName: '请输入设备名称',
    pleaseEnterTheEquipmentModel: '请输入设备型号'
  }

}



// WEBPACK FOOTER //
// ./src/lang/zh.js